import React, { Component } from "react";
import { Row, Col, Form, InputGroup, Label, Button } from "reactstrap";
import { inject, observer } from "mobx-react";
import CalendarioPicker from "../../../comum/components/Calendario";
import InputFiltro from "../../../comum/components/InputFiltro";
import SelectFiltro from "../../../comum/components/SelectFiltro";
import { Link } from "react-router-dom";
import {
  IconeSoma,
  FecharFiltro,
  IconeMailBulk,
  IconeFileImport
} from "../../../comum/components/Icones";
import Card from "../../../comum/components/Card";
import lscache from "lscache";

@inject("store")
@observer
export default class FiltrosAgendamentoNotaFiscal extends Component {
  constructor(props) {
    super(props);
    {
      /* TODO: inserir proptypes */
    }
    this.controller = this.props.controller;
    this.maisFiltros = lscache.get("notafiscal-maisFiltros");
    this.state = {
      maisFiltros: this.maisFiltros ? this.maisFiltros : false,
      filtrado: false
    };
  }

  filtrar() {
    this.setState(state => ({ filtrado: true }));
    this.controller.carregarLista();
  }

  filtros = () => {
    if (!this.state.maisFiltros) {
      return this.filtrosBasicos();
    } else {
      return this.filtrosCompletos();
    }
  };

  filtrosCompletos = () => {
    let xl = 3;
    let lg = 6;
    let md = 4;
    let sm = 6;
    let xs = 12;
    return (
      <React.Fragment>
        <Row className="align-items-end">
          <Col xl={xl} md={4} sm={6} xs={12} className="mb-4">
            <div className="w-100">
              <Col xs={12} className="col-label px-0">
                <Label>Data de Emissão</Label>
              </Col>
              <Col xs={12} className="px-0">
                <InputGroup
                  className={this.controller.seletorPeriodo ? "ativo" : ""}
                >
                  <CalendarioPicker
                    visivel={this.controller.seletorPeriodo}
                    onChangeInicio={valor =>
                      this.controller.onChangeDataInicio(valor)
                    }
                    onChangeFim={valor =>
                      this.controller.onChangeDataFim(valor)
                    }
                    dataInicial={this.controller.dataEmissaoInicioPreenchido}
                    dataFinal={this.controller.dataEmissaoFimPreenchido}
                    fechar={this.controller.toggleDataSeletor}
                    filtrar={() => {}}
                  />
                </InputGroup>
              </Col>
            </div>
          </Col>

          <InputFiltro
            titulo={process.env.rig ? "Número da Nota / DUE" : "Número da Nota"}
            xl={xl}
            md={4}
            sm={6}
            xs={12}
            onEnter={() => this.filtrar()}
            onChange={event =>
              this.controller.setFiltroSelecionado("numero", event.target.value)
            }
          />

          <InputFiltro
            titulo="Série"
            xl={xl}
            md={4}
            sm={6}
            xs={12}
            onEnter={() => this.filtrar()}
            onChange={event =>
              this.controller.setFiltroSelecionado("serie", event.target.value)
            }
          />

          <SelectFiltro
            titulo="Status"
            xl={xl}
            md={6}
            md={4}
            sm={6}
            xs={12}
            itens={this.controller.status}
            valor={this.controller.statusPreenchido}
            itensValor="Id"
            itensLabel="DscStatus"
            onChange={this.controller.setStatus}
          />

          <InputFiltro
            titulo="CNPJ do Destinatário"
            xl={xl}
            md={4}
            sm={6}
            xs={12}
            type="number"
            onEnter={() => this.filtrar()}
            onChange={event =>
              this.controller.setFiltroSelecionado(
                "cnpjDestino",
                event.target.value
              )
            }
          />

          <InputFiltro
            titulo="Razão Social do Destinatário"
            xl={xl}
            md={4}
            sm={6}
            xs={12}
            onEnter={() => this.filtrar()}
            onChange={event =>
              this.controller.setFiltroSelecionado(
                "razaoSocialDestino",
                event.target.value
              )
            }
          />

          <InputFiltro
            titulo="Container"
            xl={xl}
            md={4}
            sm={6}
            xs={12}
            onEnter={() => this.filtrar()}
            onChange={event =>
              this.controller.setFiltroSelecionado("cntr", event.target.value)
            }
          />

          <InputFiltro
            titulo="Chave"
            xl={xl}
            md={4}
            sm={6}
            xs={12}
            onEnter={() => this.filtrar()}
            onChange={event =>
              this.controller.setFiltroSelecionado("chave", event.target.value)
            }
          />

          <Col md={4} sm={6} xs={12} className="mb-4 align-bottom">
            <Button
              className="btn-filtros ativo"
              onClick={() => this.mudaFiltros()}
              outline
            >
              <FecharFiltro
                color="#93A0AD"
                className="mr-2"
                width="15"
                height="15"
              />
              Menos filtros
            </Button>
            <Button
              className="btn-com-bordas-primary btn-filtrar"
              onClick={() => this.filtrar()}
            >
              Filtrar
            </Button>
          </Col>
        </Row>
      </React.Fragment>
    );
  };

  filtrosBasicos = () => {
    let xl = 3;
    let lg = 6;
    let md = 4;
    let sm = 6;
    let xs = 12;
    return (
      <React.Fragment>
        <Row className="align-items-end">
          <Col xl={xl} md={4} sm={6} xs={12} className="mb-0">
            <div className="w-100">
              <Col xs={12} className="col-label px-0">
                <Label>Data de Emissão</Label>
              </Col>
              <Col xs={12} className="px-0">
                <InputGroup
                  className={this.controller.seletorPeriodo ? "ativo" : ""}
                >
                  <CalendarioPicker
                    visivel={this.controller.seletorPeriodo}
                    onChangeInicio={valor =>
                      this.controller.onChangeDataInicio(valor)
                    }
                    onChangeFim={valor =>
                      this.controller.onChangeDataFim(valor)
                    }
                    dataInicial={this.controller.dataEmissaoInicioPreenchido}
                    dataFinal={this.controller.dataEmissaoFimPreenchido}
                    fechar={this.controller.toggleDataSeletor}
                    filtrar={() => {}}
                  />
                </InputGroup>
              </Col>
            </div>
          </Col>
          <InputFiltro
            className="mb-0"
            titulo={process.env.rig ? "Número da Nota / DUE" : "Número da Nota"}
            xl={2}
            md={2}
            sm={6}
            xs={12}
            onEnter={() => this.filtrar()}
            onChange={event =>
              this.controller.setFiltroSelecionado("numero", event.target.value)
            }
            style="padding-left:0;"
          />

          <Col xl={xl} md={3} sm={sm} xs={xs} className="mb-0 align-bottom">
            <Button
              className="btn-filtros"
              onClick={() => this.mudaFiltros()}
              outline
            >
              <FecharFiltro
                color="#93A0AD"
                className="mr-2"
                width="15"
                height="15"
              />
              Mais filtros
            </Button>
            <Button
              className="btn-com-bordas-primary btn-filtrar"
              onClick={() => this.filtrar()}
            >
              Filtrar
            </Button>
          </Col>
        </Row>
      </React.Fragment>
    );
  };

  acoesExtras = () => {
    return (
      <Col className="justify-content-end d-flex mb-0">
        <Button
          onClick={this.controller.abrirInserirXMLNotaFiscal}
          className="btn-com-bordas-cinza btn-cinza-filtro"
        >
          <IconeFileImport tamanho="lg" className="mr-1" />
          Inserir XML
        </Button>
        <Link to="/consulta-edi-nf">
          <Button className="btn-com-bordas-cinza btn-cinza-filtro">
            <IconeMailBulk tamanho="lg" className="mr-1" /> Consulta EDI NF
          </Button>
        </Link>
        <Link to="agendamento-nota-fiscal/cadastro">
          <Button className="btn-com-bordas-primary">
            Nova Nota Fiscal
          </Button>
        </Link>
      </Col>
    );
  };

  mudaFiltros = () => {
    this.setMaisFiltros(!this.state.maisFiltros);
    this.setState({ maisFiltros: !this.state.maisFiltros });
  };

  setMaisFiltros(bool) {
    lscache.set("notafiscal-maisFiltros", bool, 5);
  }

  render() {
    return (
      <Card className="mb-0">
        <div className="filtros agendamento m-0 p-0">{this.filtros()}</div>
      </Card>
    );
  }
}



// WEBPACK FOOTER //
// ./src/modules/agendamento/nota-fiscal-visualizar/components/FiltrosAgendamentoNotaFiscal.js